export enum Browser {
    Chrome,
    Edge,
    Firefox,
    InternetExplorer,
    Opera,
    Safari,
    Unknown
}
